export const SLOTS = [
  ["front_drive", "Front drive"],
  ["parking", "Parking"],
  ["front_of_house", "Front of house"],
  ["rear_access", "Access to the rear"],
  ["garden_view", "Garden view"],
  ["rear_of_house", "Rear of house view"],
  ["internal_views", "Internal views"],
];

export const money = (n) => "£" + Math.round(n || 0).toLocaleString("en-GB");
